// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { applyAspectRatioBoxStyles, applyAspectRatioBoxInsideStyles } from '@tcp/core/src/utils';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 10px 0;

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 16px 0;
  }
`;

export const Container = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: auto;
  scroll-behavior: auto;
  gap: ${(props) => (props.imageTileSpace ? `${props.imageTileSpace}px` : ``)};

  /* Hide scrollbars in all major browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

export const Media = styled(DamImage)`
  display: block;
  object-fit: fill;
  flex-shrink: 0;
  cursor: pointer;
  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;

export const FadeOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 200px;

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    width: 100px;
  }

  z-index: 10;
  pointer-events: none;

  ${(props) =>
    props.left
      ? `left: 0; background: linear-gradient(to right, white, transparent);`
      : `right: 0; background: linear-gradient(to left, white, transparent);`}
`;

export const Card = styled.div`
  background: white;
  width: ${(props) => (props.widthVal ? `${props.widthVal}%` : `175px`)};

  ${(props) =>
    !props.imageCardDesignHidden &&
    `
      border-radius: 16px;
      border: 2px solid #d9d9d9;
  `}

  overflow: hidden;
  flex-shrink: 0;
  transition: transform 0.3s ease;

  ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;
